import { isRecord, readStored, writeStored } from './storage';

const KEY = 'khaddi.client.paymentUrls';

/**
 * The API only hands out the gateway URL when the order is placed, so it is kept
 * per order to offer "Thanh toán lại" on the tracking screen.
 */
export const rememberPaymentUrl = (orderId: string, url: string): void => {
  const stored = readStored(KEY);
  const urls = isRecord(stored) ? stored : {};
  writeStored(KEY, { ...urls, [orderId]: url });
};

export const paymentUrlFor = (orderId: string): string | null => {
  const stored = readStored(KEY);
  const url = isRecord(stored) ? stored[orderId] : null;
  return typeof url === 'string' ? url : null;
};

/** Sends the browser to the sandbox gateway, which redirects back to the order's tracking page. */
export const openPayment = (paymentUrl: string, orderId: string): void => {
  const back = `${window.location.origin}${window.location.pathname}#/orders/${encodeURIComponent(orderId)}`;
  window.location.assign(`${paymentUrl}&return=${encodeURIComponent(back)}`);
};
